import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import DocumentBody from "../DocumentBody";
import BackgroundCarousal from "./BackgroundCarousal";

gsap.registerPlugin(ScrollTrigger);

export default class PrimaryMenu {
  static instance;

  constructor() {
    if (PrimaryMenu.instance) {
      return PrimaryMenu.instance;
    }
    PrimaryMenu.instance = this;


    this.isHome = false;
    this.documentBody = new DocumentBody();
    this.buttonTrigger = document.getElementById("sticky-header-trigger");
    this.buttonClose = document.getElementById("primary-menu-close");
    this.buttonTrigger.addEventListener("click", this.open);
    this.buttonClose.addEventListener("click", this.close);

    new BackgroundCarousal();
  }

  pages() {
    gsap.set("#primary-menu", { autoAlpha: 0 });
  }

  open(event) {
    event.preventDefault();
    document.documentElement.style.overflow = "hidden"; // firefox, chrome
    document.body.scroll = "no"; // ie only

    gsap.to("#primary-menu", { autoAlpha: 1 });

    if (this.isHome) {
      gsap.to("#sticky-header", { top: -100 });
    }
  }

  close(event) {
    event.preventDefault();
    document.documentElement.style.overflow = "auto"; // firefox, chrome
    document.body.scroll = "yes"; // ie only

    gsap.to("#primary-menu", { autoAlpha: 0 });

    if (this.isHome) {
      gsap.to("#sticky-header", { top: 0 });
    }
  }

  homepage() {
    this.isHome = true;

    const height = gsap.getProperty("#sticky-header", "height");

    gsap.set("#sticky-header", { autoAlpha: 0, y: -height });

    this.menuTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: ".mantis-svg-container > svg",
        start: "top 20%",
        end: "top 10%",
        scrub: true,
        markers: false,
      },
    });

    this.menuTimeline.to("#sticky-header", {
      autoAlpha: 1,
      y: 0,
    });

    this.menuTrigger = document.getElementById("menu-trigger");
    this.menuTrigger.addEventListener("click", this.open, false);
  }
}
